/**
 * A country in words (TMMPDM-0112): an ISO 3166-1 alpha-2 code as the locale names it ("Costa Rica",
 * "Estados Unidos"). A code Intl doesn't know shows the code; "—" when none was sent.
 */
import { NOT_SENT, type Maybe } from './money';

export function formatCountry(code: Maybe<string>, locale: string): string {
  if (code === null || code === undefined || code.trim() === '') return NOT_SENT;
  const upper = code.trim().toUpperCase();
  try {
    return new Intl.DisplayNames([locale], { type: 'region', fallback: 'code' }).of(upper) ?? upper;
  } catch {
    return upper;
  }
}
